import {BeginSealDeviceMethodInterceptor, DeviceInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import {DeviceBeginSealType} from "@hybird/core/device/protocol";

export class ContinuousAutoSealStretchInterceptor extends BeginSealDeviceMethodInterceptor {

  async beginSeal(proceed, self, params = {}) {
    const result = await proceed(params);

    if (self.option.autoSealStretch
            && self.deviceProtocol.deviceInfo.sealAuthentication !== 1
            && self.option.remote === DeviceBeginSealType.continuous
            && self.deviceProtocol.deviceInfo.sealDiscern !== 1) {
      await self.sealStretch({out: true});
    } else {
      const remoteLockStatus = self.option.remote === DeviceBeginSealType.remote ||
              (self.option.remote === DeviceBeginSealType.continuous && self.deviceProtocol.deviceInfo.sealDiscern === 1);

      if (self.deviceProtocol.version >= 3) {
        self.remoteLockStatus = self.deviceProtocol.deviceInfo.sealAuthentication === 1 || self.deviceProtocol.deviceInfo.sealDiscern === 1;
      } else {
        self.remoteLockStatus = remoteLockStatus;
      }
    }

    return result;
  }

  async sealStretch(proceed, self, params = {}) {
    const result = await proceed(params);
    self._remoteLockStatus = !params.out;

    return result;
  }

  isSupport(deviceBeginSeal) {
    return true;
  }
}